import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Химия. 11 класс",
        subject: "Катализ и катализаторы",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Катализ и катализаторы",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Заграничная Надежда Анатольевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории профильного образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>В курсе общей химии тема «Катализ и катализаторы» имеет такое же большое мировоззренческое значение, как и изучение темы «Ферменты» в курсе биологии. В кейсе представлен пример межпредметного урока, объединяющего химическое и биологическое содержание. </p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>В рамках этой формы организации обучения межпредметные связи позволяют наиболее эффективно достигать целей и решать задачи образования. Но из педагогической практики известно, что учителям-предметникам сложными представляются этапы межпредметного урока, связанные с созданием проблемной ситуации и решением учебной межпредметной проблемы в условиях необходимости освоения содержания различных учебных дисциплин. Материалы методического кейса призваны оказать помощь учителю в решении подобных задач. </p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>Данный урок не только формирует представления о катализе, но и значительно расширяет знания учеников о катализаторах и ферментах. Используемые приёмы обучения: постановка межпредметных вопросов; выполнение комплексных заданий; составление графиков, таблиц и классификационных схем; перенос и применение химических теорий для объяснения природных явлений и процессов в живых организмах, способствуют формированию естественно-научной грамотности выпускников средней школы.</p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>В то же время, отбор актуального учебного материала, отражающего уровень развития современной науки, а также приближенного к жизненному опыту и интересам обучающихся, является ещё не решенной задачей, и может вызывать затруднения в работе учителя. Материалы данного кейса будут полезны учителю-предметнику как в определении содержания обучения на уроке, так и при организации учено-познавательной деятельности обучающихся в урочной и внеурочной работе. </p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>Материалы, представленные в методическом кейсе, помогут учителям химии и биологии организовать работу по достижению личностных, метапредметных и предметных результатов освоения образовательной программы. Методы и формы проведения урока способствует развитию познавательной мотивации и интереса к обучению, повышению уровня естественно-научной грамотности. </p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>
                                В составе материалов кейса:
                                </p>
                                <ul>
                                <li>приведены актуальные проблемные ситуации, соответствующие теме урока; </li>
                                <li>рассмотрены возможности использования приёмов межпредметной и внутрипредметной интеграции для более полного раскрытия содержания;</li>
                                <li>предложены варианты организации учебно-познавательной деятельности школьников на уроке при освоении как химического, так и биологического содержания;</li>
                                <li>включён дидактический материал (задания разной сложности) для обучающихся, который учитель может использовать как на уроке, так и для домашней работы;</li>
                                <li>приведён текст методической статьи, которая знакомит учителей-предметников с формами организации интегративного обучения.</li>
                                </ul>
                                </div>

                                `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Урок «Катализ и катализаторы» может быть эффективно проведен на основе межпредметной интеграции курсов общей химии и общей биологии.  </p>
                    <p style="text-indent: 2vw;">В плане урока показана возможная реализация межпредметных связей.</p>
                    <p style="text-indent: 2vw;">План изучения темы следующий:
                    <ol>
                    <li>Почему в окружающем мире происходят не все возможные химические реакции? (Создание проблемной ситуации и определение проблемы урока).</li>
                    <li>Закономерности протекания химической реакции (Актуализация имеющихся знаний).</li>
                    <li>Механизм влияния катализатора на скорость протекания химической реакции (Формулирование гипотезы. Обоснование гипотезы).</li>
                    <li>Особенности биологических катализаторов – ферментов (Обоснование гипотезы).</li>
                    <li>Проведение исследовательского эксперимента (экспериментальная проверка гипотезы).</li>
                    <li>Применение неорганических катализаторов и ферментов в науке и технологиях (Следствия из гипотезы).</li>
                    <li>Обобщение и формулирование выводов по теме урока.</li>
                    </ol>
                    </p>
                    <p style="text-indent: 2vw;">Содержание урока позволят обращаться к примерам, отражающим понятные школьникам жизненные ситуации, связанные со здоровьем, продуктами питания, технологиями получения важнейших видов химической и микробиологической продукции. </p>
                    <p style="text-indent: 2vw;">На уроке учитель может использовать частично-поисковый, проблемный или исследовательский методы обучения. В рамках каждого из методов учитель организует с обучающимися работу, включающую установление причин явлений, выявление проблемы, прогнозирование возможных способов их решения, подтверждение гипотез на практике. </p>
                    <p style="text-indent: 2vw;">Урок может быть проведён в различных формах: эвристическая беседа, семинар, дискуссия, практикум, защита проектов или творческих заданий.</p>
                    <p style="text-indent: 2vw;">Выбор метода и наиболее подходящих форм организации учебной работы зависит от уровня подготовленности учеников класса к самостоятельной учебно-познавательной деятельности.</p>
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральная образовательная программа среднего общего образования. \n" +
                "URL: https://edsoo.ru/Federalnaya_obrazovatelnaya_programma_srednego_obschego_obrazovaniya.htm (Дата обращения: 14.02.2023)\n",
                "Заграничная Н.А., Паршутина Л.А. Интеграция содержания и методов преподавания естественно-научных предметов в школьном образовании / Н.А. Заграничная, Л.А. Паршутина // Педагогика. 2018, №9",
                "Заграничная Н.А., Паршутина Л.А. Функциональная грамотность учащихся: условия и пути формирования// Химия в школе. 2020. №7",
                "Кузнецова Н.Е., Шаталов М.А. Обучение химии на основе межпредметной интеграции: 8-9 классы: учебно-методическое пособие. – Москва: Вентана-Граф, 2008",
                "Единое содержание общего образования (edsoo.ru)",
                "Сайт ИСРО. Режим достyпа: https://skiv.instrao.ru",
                "Российская электронная школа (resh.edu.ru)"
            ],
            sites: [],
            filesToDownload: [
                {
                    link: "./files/additional1.pdf",
                    fileName: "Комплексное задание №1"
                },
                {
                    link: "./files/additional2.pdf",
                    fileName: "Комплексное задание №2"
                },
                {
                    link: "./files/additional3.pdf",
                    fileName: "Лабораторная работа №1"
                },
                {
                    link: "./files/additional4.pdf",
                    fileName: "Лабораторная работа №2"
                },
                {
                    link: "./files/additional5.pdf",
                    fileName: "Методическая статья"
                },
                {
                    link: "./files/additional6.pdf",
                    fileName: "Текстовые задания по теме урока"
                },
            ]
        }
    ],
};
